import React from 'react';

const Footer = () => {
  return (
    <div className='footer-styles'>
      <h3 id='made-by'>Made at ❤️General Assembly❤️ by Ana & Tom</h3>
    </div>
  );
};

export default Footer;
